module.exports = __webpack_public_path__ + "img/uspto.afa2e05c.png";